const RATE_NAME_EN = {
    'Базовый': 'Basic',
    'Базовый тариф': 'Basic',
    'Низкий сезон': 'Low season',
    'Высокий сезон': 'High season',
    'Городской': 'City',
};

export const translateRateName = (name, lang = 'ru') => {
    if (!name || lang !== 'en') {
        return name || '';
    }

    const normalized = String(name).trim();
    return RATE_NAME_EN[normalized] || normalized;
};
